import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

import { isEmail } from './email-utils';

import TextInputWithError from '../TextInputWithError/TextInputWithError';

export const EmailInput = ({
  className,
  onChange,
  onSubmit,
  onEntryValidation,
  onValueError,
  onBlur,
  placeholder = 'Email',
  block = false,
}) => {
  const [emailText, setEmailText] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (value) => {
    if (value && value?.trim()?.length && isEmail(value)) {
      if (isFunction(onSubmit)) {
        onSubmit(value)
      }
      setEmailText('');
    }
  };

  const handleChange = (value) => {
    if (isFunction(onChange)) {
      onChange(value);
    }
    setEmailText(value);
  }

  const handleValueError = useCallback((error) => {
    if (isFunction(onValueError)) {
      onValueError(error)
    }
  }, [onValueError])

  const handleBlur = useCallback((event) => {
    if (isFunction(onBlur)) {
      onBlur(event);
    }
  }, [onBlur])

  const handleEntryValidation = useCallback(value => !value?.length || (isEmail(value) && (!isFunction(onEntryValidation) || onEntryValidation(value))), [onEntryValidation])

  return (
    <TextInputWithError
      type="text"
      className={classNames(className)}
      ref={inputRef}
      placeholder={placeholder}
      value={emailText}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onEntryValidation={handleEntryValidation}
      onValueError={handleValueError}
      onBlur={handleBlur}
      errorMessage="Invalid Email"
      block={block}
    />
  )
};

export default EmailInput;
